import { FC, Fragment, useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { getDepartureMismatchIndexes } from 'entities/ticket/lib/get-departure-mismatch-indexes'
import DirectionDetail, {
  IDirectionDetail,
} from 'entities/ticket/ui/direction-detail'
import { RouteInfoAlert } from 'entities/ticket/ui/route-info-alert'

import { Segment } from 'shared/models/ticket'

import s from './styles.module.scss'

interface Props {
  detailTicketInfo: IDirectionDetail[]
  resultsAllListDirections: Segment[][]
  isDifficultRoute: boolean
  onDetail: (directionIndex: number, flyIndex: number) => void
  getDirectionKey?: (group: IDirectionDetail, index: number) => string
}

export const TicketDirectionDetails: FC<Props> = ({
  detailTicketInfo,
  resultsAllListDirections,
  isDifficultRoute,
  onDetail,
  getDirectionKey,
}) => {
  const { t } = useTranslation()

  const mismatchIndexes = useMemo(
    () => getDepartureMismatchIndexes(resultsAllListDirections),
    [resultsAllListDirections],
  )

  return (
    <>
      {detailTicketInfo.map((group, index) => (
        <Fragment key={getDirectionKey?.(group, index) ?? group.title}>
          <DirectionDetail
            {...group}
            onDetail={(flyIndex) => onDetail(index, flyIndex)}
          />

          {isDifficultRoute && mismatchIndexes.includes(index) && (
            <div className={s.alert}>
              <RouteInfoAlert iconColor="var(--danger)">
                {t('detail_ticket.departure_point_mismatch')}
              </RouteInfoAlert>
            </div>
          )}
        </Fragment>
      ))}
    </>
  )
}
